export default {"src":"/_next/static/media/pharmacy-order-three.82b48310.svg","height":300,"width":322,"blurWidth":0,"blurHeight":0};